import { render, staticRenderFns } from "./playEatInfoCom.vue?vue&type=template&id=10dcc215&scoped=true"
import script from "./playEatInfoCom.vue?vue&type=script&lang=js"
export * from "./playEatInfoCom.vue?vue&type=script&lang=js"
import style0 from "./playEatInfoCom.vue?vue&type=style&index=0&id=10dcc215&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dcc215",
  null
  
)

export default component.exports